import React, { Component } from "react";
import { getDataSources } from "../../../services/dataSourceService";
import CustomLoader from "../../common/Loader";
import {
    getDT,
    saveDT,
    getSPV,
    findParameters,
} from "../../../services/formService";
import * as Icon from "react-feather";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { ResultSource, RowActions } from "../../../constants/ResultSource";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getProjectForms } from "../../../services/projectService";
import { logActivity } from "../../../services/utilService";

class WDataElement extends Component {
    DataSources = [];
    Forms = [];
    RowActions = [];
    ResultSources = [];
    StoredProcedures = [];
    Views = [];

    state = {
        Project_ID: this.props.Project_ID,
        Form_ID: this.props.Form_ID,
        Widget_ID: this.props.Widget.Widget_ID,
        DT_ID: 0,
        DataSource_ID: 0,
        ResultSource_ID: 0,
        ResultSource_Content: "",
        Display_Name: "",
        Parameters: [],
        can_save: false,
        open_options: "",
        loading: false,
    };

    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSPVChange = this.handleSPVChange.bind(this);
    }

    getOptions = async (value) => {
        const { data } = await getSPV(value, this.getConn());
        if (value === ResultSource.SP) {
            this.StoredProcedures = data;
        } else if (value === ResultSource.View) {
            this.Views = data;
        }
    };

    async loadDT() {
        const { data } = await getDT(this.state.Widget_ID);

        let { data: Forms } = await getProjectForms(this.state.Project_ID);
        this.Forms = Forms.filter((form) => form.Form_ID !== this.props.Form_ID);
        this.RowActions = JSON.parse(data.rowActions);
        this.ResultSources = JSON.parse(data.resultSources);
        const DT = JSON.parse(data.DT)[0];
        if (DT) {
            this.setState({ DT_ID: DT.DT_ID });
            this.setState({ DataSource_ID: DT.DataSource_ID });
            this.setState({ ResultSource_ID: DT.ResultSource_ID });
            this.setState({ ResultSource_Content: DT.ResultSource_Content });
            this.setState({ open_options: DT.ResultSource_Content });
            this.setState({ Display_Name: DT.Display_Name });
            this.setState({ Parameters: JSON.parse(data.Parameters) });
            this.getOptions(DT.ResultSource_ID);
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        const { data: DS } = await getDataSources();
        this.DataSources = DS;
        this.loadDT();
        this.setState({ loading: false, can_save: true });
    }

    handleChange = (input) => {
        let value = input.value;
        (input.name.includes("ID")) && (value = parseInt(value));
        this.setState({ [input.name]: value });
    };

    getConn() {
        const source = this.DataSources.find((source) => {
            return source.DataSource_ID === this.state.DataSource_ID;
        });
        return source.Connection_String;
    }

    handleResultSourceChange = async (input) => {
        const name = input.name.split(":").pop();
        let value = parseInt(input.value);
        this.setState({ [name]: value });
        this.getOptions(value);
    };

    handleSPVChange = async (e, value) => {
        this.setState({ ResultSource_Content: value });
        if (this.state.ResultSource_ID === ResultSource.SP) {
            const { data } = await findParameters(value, this.getConn());
            if (typeof data === "object") {
                const Parameters = data.map((par) => {
                    par.Parameter_ID = 0;
                    par.Default_Value = "";
                    if ((par.Name).toLowerCase().includes('institution')) {
                        let institutionElId = document.getElementById('userInst').value; par.Default_Value = institutionElId;
                    }
                    return par;
                });
                this.setState({ Parameters });
            }
        }
    };

    handleSave = async () => {
        const { data } = await saveDT(this.state);
        if (data.includes("Error")) {
            toaster('error', data);
            logActivity('/formBuilder', 'WIDGET_DE_SAVE_FAILED');
        } else {
            toaster('success', 'Widget saved. Please update linked widgets, if any!');
            logActivity('/formBuilder', 'WIDGET_DE_SAVE_SUCCESS');
            const DT_ID = data.split(":").pop();
            this.setState({ DT_ID });
            this.loadDT();
        }
    };

    handleRemove = () => {
        this.props.onRemove(this.state.Widget_ID);
    };

    handldParChange = (text, index) => {
        const Parameters = [...this.state.Parameters];
        Parameters[index]["Default_Value"] = text;
        this.setState({ Parameters });
    };

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }

        const {
            DataSource_ID,
            Action_ID,
            Action_Form_ID,
            ResultSource_ID,
            Display_Name,
            ResultSource_Content,
            Widget_ID,
            open_options,
            Parameters,
            enableServerSidePaging,
            enableDownloadDT,
            enablePrintDT,
            enableFilterDT,
        } = this.state;

        return (
            <React.Fragment>
                <div className="form-group" key={Widget_ID}>
                    <label htmlFor={"Display_Name" + Widget_ID}>Display Name</label>
                    <input
                        className="form-control"
                        id={"Display_Name" + Widget_ID}
                        type="text"
                        name="Display_Name"
                        value={Display_Name}
                        onChange={(e) => this.handleChange(e.target)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor={"DataSource" + Widget_ID}>Data Source</label>
                    <select
                        id={"DataSource" + Widget_ID}
                        className="form-control"
                        value={DataSource_ID}
                        name="DataSource_ID"
                        onChange={(e) => this.handleChange(e.target)}
                    >
                        <option value="0">Select</option>
                        {this.DataSources.map((source) => {
                            return (
                                <option key={source.DataSource_ID} value={source.DataSource_ID}>
                                    {source.Description}
                                </option>
                            );
                        })}
                    </select>
                </div>

                {DataSource_ID !== 0 && (
                    <React.Fragment>
                        <div className="form-group">
                            {this.ResultSources.map((source, index) => {
                                return (
                                    <div className="form-check form-check-inline" key={Widget_ID + source.ResultSource_Type_Name}>
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id={Widget_ID + source.ResultSource_Type_Name}
                                            name={Widget_ID + ":ResultSource_ID"}
                                            value={source.ResultSource_ID}
                                            checked={source.ResultSource_ID === ResultSource_ID}
                                            onChange={(e) => this.handleResultSourceChange(e.target)}
                                        />
                                        <label
                                            htmlFor={Widget_ID + source.ResultSource_Type_Name}
                                            className="form-check-label"
                                        >
                                            {source.ResultSource_Type_Name}
                                        </label>
                                    </div>
                                );
                            })}

                            {ResultSource_ID === ResultSource.Query && (
                                <div>
                                    <TextField
                                        id={Widget_ID + "resultSourceContent"}
                                        label="Enter Query"
                                        variant="outlined"
                                        fullWidth
                                        margin="dense"
                                        name="ResultSource_Content"
                                        value={ResultSource_Content}
                                        onChange={(e) => this.handleChange(e.target)}
                                    />
                                </div>
                            )}

                            {(ResultSource_ID === ResultSource.SP ||
                                ResultSource_ID === ResultSource.View) && (
                                    <div>
                                        <Autocomplete
                                            id={Widget_ID + "resultSourceContent"}
                                            options={
                                                open_options
                                                    ? ResultSource_ID === ResultSource.SP
                                                        ? this.StoredProcedures
                                                        : this.Views
                                                    : []
                                            }
                                            getOptionLabel={(option) => option}
                                            fullWidth
                                            size="small"
                                            value={ResultSource_Content}
                                            name="ResultSource_Content"
                                            onChange={this.handleSPVChange}
                                            inputValue={open_options}
                                            onInputChange={(e, val) => {
                                                this.setState({ open_options: val });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={
                                                        ResultSource_ID === ResultSource.SP
                                                            ? "Stored Procedure Name"
                                                            : "View Name"
                                                    }
                                                />
                                            )}
                                        />
                                    </div>
                                )}

                            {ResultSource_ID === ResultSource.SP &&
                                Parameters.length > 0 &&
                                Parameters.map((par, idx) => {
                                    return (
                                        <TextField
                                            id={Widget_ID + "." + par.Name}
                                            key={Widget_ID + "." + par.Name}
                                            label={par.Name + "(" + par.Type + ")"}
                                            placeholder="Default Value"
                                            fullWidth
                                            value={par.Default_Value}
                                            onChange={(e) =>
                                                this.handldParChange(e.target.value, idx)
                                            }
                                        />
                                    );
                                })}
                        </div>
                    </React.Fragment>
                )}
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-outline-primary mr-2"
                        onClick={this.handleSave}
                        disabled={!this.state.can_save}
                    >
                        Save
                    </button>
                    <button
                        className="btn btn-outline-danger"
                        onClick={this.handleRemove}
                    >
                        Delete
                    </button>
                </div>
                <ToastContainer />
            </React.Fragment>
        );
    }
}

export default WDataElement;
